export default __webpack_public_path__ + "static/media/tickets_mob@2x.eb42d3a5.png";